module.exports = __webpack_public_path__ + "static/seatGuest2-99953a4e81b8c9910562e0492897f31a.png";